export const LAWYERS_REQUEST = 'LAWYERS_REQUEST';
export const LAWYER_SAVE = 'LAWYER_SAVE';
export const LAWYER_GET_NEW_ID = 'LAWYER_GET_NEW_ID';
export const LAWYER_REQUEST_BY_ID = 'LAWYER_REQUEST_BY_ID';
export const LAWYERS_SUCCESS = 'LAWYERS_SUCCESS';
export const LAWYERS_REPLACE = 'LAWYERS_REPLACE';
export const LAWYERS_UPLOAD_FILE = 'LAWYERS_UPLOAD_FILE';
